/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Research_TitleInputs */

const en_cap_research_title = /** @type {(inputs: Cap_Research_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Research that shows its sources.`)
};

const lv_cap_research_title = /** @type {(inputs: Cap_Research_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Izpēte, kas parāda savus avotus.`)
};

/**
* | output |
* | --- |
* | "Research that shows its sources." |
*
* @param {Cap_Research_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cap_research_title = /** @type {((inputs?: Cap_Research_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Research_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cap_research_title(inputs)
	return en_cap_research_title(inputs)
});